// extracted by mini-css-extract-plugin
export default {"products":"style_products__fs0ZG","content":"style_content__kGyFK","productsList":"style_productsList__zkX-i","header":"style_header__IFDjE"};